import { useEffect, useState } from 'react';
import { SortModel } from 'src/components/commons/subTable/types';
import useCannedNotesStore from 'src/hooks/stores/useCannedNotesStore';
import { useCannedNotesHeaders } from 'src/hooks/useCannedNotesHeaders';
import { CannedNoteModel } from 'src/models/cannedNote.model';

const useCannedNotesTable = () => {
  const { dataSource, loadPage, deleteBulk, updateOne, createOne } = useCannedNotesStore();
  const { columns, setColumns } = useCannedNotesHeaders();
  const [newRecord, setNewRecord] = useState({ note: '' });
  const viewportHeight = window.innerHeight - 275;

  const handleSortChange = (sort: SortModel | undefined) => {
    console.log(sort);
  };
  const handleFilterChange = (filter: any) => {
    console.log(filter);
  };

  const handleDeleteRows = (rows: CannedNoteModel[]) => {
    deleteBulk(rows.map((row) => row.id));
  };

  const handleEditRows = (rows: CannedNoteModel[]) => {
    rows.forEach((row) => updateOne(row));
  };

  const autocompleteFieldSearch = async (
    field: string,
    search: string,
    dataType: string | number | string[],
    dataIndex?: string,
  ) => {
    const lowercased = search.toLowerCase();
    const filtered = dataSource
      .filter((row: CannedNoteModel) => row.note?.toLowerCase()?.includes(lowercased))
      .splice(0, 200);
    return {
      results: filtered,
      filter: filtered.map((row) => ({
        value: row[dataIndex || field],
        label: row[dataIndex || field],
      })),
    };
  };

  const postData = (args: Record<string, unknown>) => {
    setNewRecord((prev) => ({
      ...prev,
      [args?.dataIndex as string]: args?.value as string,
      autoSave: !!args?.autoSave,
    }));
  };

  const resetNewRecord = () => {
    setNewRecord({ note: '' });
  };

  const createNewRecord = async () => {
    const { note } = newRecord;
    if (!note) return;
    await createOne({ note });
    resetNewRecord();
  };

  useEffect(() => {
    loadPage({ start: 0, renderLen: 120 });
  }, []);

  return {
    viewportHeight,
    columns,
    dataSource,
    newRecord,
    resetNewRecord,
    loadPage,
    setColumns,
    handleSortChange,
    handleFilterChange,
    handleDeleteRows,
    handleEditRows,
    autocompleteFieldSearch,
    postData,
    createNewRecord,
  };
};

export default useCannedNotesTable;
